import { ButtonV2 } from '@ghq-abi/design-system';
import { ArrowsFullscreenIcon } from '@ghq-abi/design-system-icons';
import { useTranslate } from '@tolgee/react';

import { useFullscreen } from '~/app/contexts/FullscreenContext';

export function FullScreenActivate({
  disabled,
  onActivate,
}: {
  disabled?: boolean;
  onActivate?: () => void;
}) {
  const { t } = useTranslate('web-app');

  const fullscreen = useFullscreen();

  function handleClick() {
    fullscreen.activate();
    onActivate?.();
  }

  return (
    <ButtonV2
      leftIcon={<ArrowsFullscreenIcon />}
      variant="secondary"
      size="md"
      onClick={handleClick}
      title={t('actions.activate', { t: t('common.fullscreen') })}
      disabled={disabled}
      aria-label={t('common.fullscreen')}
    >
      {t('common.fullscreen')}
    </ButtonV2>
  );
}
